module.exports = {"Save":"Salvați","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Tastează pentru a căuta (* pentru toate)","shipment.packagingSender":"Expeditor","Supplier":"Furnizor"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/ro.json
// module id = 1355
// module chunks = 1